import { render, staticRenderFns } from "./PublicActivityDetailScreen.vue?vue&type=template&id=3b4e45e2&"
import script from "./PublicActivityDetailScreen.vue?vue&type=script&lang=js&"
export * from "./PublicActivityDetailScreen.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports